import React, {useEffect, useState} from 'react';
import './AddSizeMulti.scss';
import TitleWithLine from "../TitleWithLine/TitleWithline";
import LabelSelectBox from "../LabelSelectBox/LabelSelectBox";
import TwoColumnTable from "../TwoColumnTable/TwoColumnTable";

const AddSizeMulti = ({sendData, ProducData, setSendData}) => {


  const boxHandler = (e, v) => {

    let addedToTable = false;
    const label = v.label;
    const value = v.value;
    const uniqId = (Math.random() * 1000000000);
    const temp = [...sendData?.size];

    temp.forEach(v => {
      if (v.value === value) {
        addedToTable = true;
      }
    })

    if (!addedToTable) {
      temp.push({uniqId, label, value})
      setSendData({...sendData, size: temp})
    }
  }
  const ItemDataHandler = (v) => {
    setSendData({...sendData, size: v});
  }

  try {
    return (
      <div className="main-size-multi">

        <TitleWithLine title="تعریف سایز" LineClass="line-solid"/>

        <LabelSelectBox
          labelText={"سایز"}
          defaultValue={""}
          options={ProducData?.size}
          onSelect={boxHandler}
          emptyInputAfterSubmit={true}
        />

        <TwoColumnTable
          title="تعریف سایز"
          TabelData={sendData?.size}
          TalelItemData={ItemDataHandler}
        />

      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
}

export default AddSizeMulti;